/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type ReasonForDataRequest = typeof ReasonForDataRequest[keyof typeof ReasonForDataRequest];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReasonForDataRequest = {
  EnergySaving: 'EnergySaving',
  Monitoring: 'Monitoring',
  Planning: 'Planning',
  Research: 'Research',
  LegalObligation: 'LegalObligation',
  Other: 'Other',
  OptimiseBulkUse: 'OptimiseBulkUse',
} as const;
